export const KEY_CODE = {
    BACKSPACE: 8,
    DELETE: 46,
    ENTER: 13
};
export const TIME_VALUES = {
    MASK_DELAY: 800
};
//# sourceMappingURL=constants.js.map